import React, { useEffect, useState } from 'react';
import { PulseLoader } from 'react-spinners';
import moment from 'moment';
import BymMap from '../Common/Map/BymMap';
import httpClient from '../../api/httpClient';
import {
  AVVIKTYPE_ENTREPRENOR,
  AVVIKTYPE_KONTROLLOR,
  getAvvikIcon,
} from '../../utils/avvikUtils';
import { getNorwegianLocalTime } from '../../utils/dateUtils';

// type Props = {};

interface Avvik {
  avviktypeId: string;
  nummer: string;
  latitude: number;
  longitude: number;
  meldingstype: string;
  seksjon: string;
  arbeidstype: string;
  feiltype: string;
  adresse: string;
  utfort: string;
  botgrunnlag: boolean;
  linkUrl: string;
  id: string;
  status: string | null;
  meldingsstatusId: string | null;
}

const DashboardDriftsavvikMapContainer = (): JSX.Element => {
  const defaultZoom = 12;
  const [loading, setLoading] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(defaultZoom);
  const [avvik, setAvvik] = useState<Avvik[]>([]);
  const [sisteRegistrerteAvvik, setSisteRegistrerteAvvik] =
    useState<Avvik | null>(null);

  const hentAvvik = async () => {
    const fra = getNorwegianLocalTime(moment().subtract(3, 'day').format());
    const til = getNorwegianLocalTime();
    setLoading(true);
    try {
      // endepunkt kun for dashboard-brukere
      const data = await httpClient.getAvvikListeforDashboard(fra, til);

      setAvvik(data.result);

      setSisteRegistrerteAvvik(
        data.result && data.result.length > 0
          ? data.result.sort((a: Avvik, b: Avvik) =>
              moment(b.utfort).diff(moment(a.utfort))
            )[0]
          : null
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    hentAvvik();
    const intervalId = setInterval(() => {
      hentAvvik();
    }, 900000);
    return () => clearInterval(intervalId);
  }, []);

  const getAvvikmarkers = () => {
    if (avvik.length === 0) return [];

    const markers = avvik
      .filter((item) => item.status === '52584cb4-b9b4-4978-be38-d87ccf149efc')
      .map((item) => {
        return {
          position: [item.latitude, item.longitude],
          title: item.adresse,
          key: item.id,
          utfort: item.utfort,
          icon: getAvvikIcon(item),
        };
      });

    return markers;
  };

  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
      }}
    >
      <BymMap
        defaultZoom={defaultZoom}
        defaultCenter={[59.88, 10.813]}
        markerClusterLimit={1000}
        onMapViewportChanged={(e) => setZoomLevel(e.zoom)}
        markers={getAvvikmarkers()}
        hideKartlag
        hideKartlagvelger
      />
      <div
        style={{
          position: 'absolute',
          left: '20px',
          bottom: '20px',
          zIndex: 99999,
          fontSize: '20px',
          color: '#fff"',
          backgroundColor: 'black',
          padding: '10px',
          transition: 'height 1s',
          height: 'auto',
        }}
      >
        <PulseLoader loading={loading} color="#fff" />
        <span
          style={{
            fontSize: '30px',
          }}
        >
          Driftsavvik
        </span>
        <br />
        <span
          style={{
            fontSize: '25px',
          }}
        >
          Åpne avvik fra siste 3 døgn
        </span>
        <br />
        Sist oppdatert: {moment().format('DD.MM.YYYY HH:mm')}
        <br />
        {sisteRegistrerteAvvik &&
          `Siste registrerte avvik: ${moment(
            sisteRegistrerteAvvik.utfort
          ).format('DD.MM.YYYY HH:mm')}`}
      </div>
      <div
        style={{
          position: 'absolute',
          right: '20px',
          bottom: '20px',
          zIndex: 99999,
          fontSize: '20px',
          color: '#fff"',
          backgroundColor: 'black',
          padding: '10px',
        }}
      >
        <div
          style={{
            fontSize: '15px',
            padding: '2px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          Kontrollør:{' '}
          <img
            src={getAvvikIcon({ avviktypeId: AVVIKTYPE_KONTROLLOR })}
            alt="Kontrollør"
          />
        </div>
        <div
          style={{
            fontSize: '15px',
            padding: '2px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          Entreprenør:{' '}
          <img
            src={getAvvikIcon({ avviktypeId: AVVIKTYPE_ENTREPRENOR })}
            alt="Entreprenør"
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardDriftsavvikMapContainer;
